import { Component, ContentChild, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Select } from '@ngxs/store';
import { transitions } from '@prisma/animations/animations';
import { AppState } from 'app/store/store.state';
import { DestroySubscribers } from 'core/decorators/destroy-subscribers.decorator';
import { fromEvent, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ToolbarItemModel } from './ian-default-toolbar.model';

@Component({
  selector: 'ian-default-toolbar',
  templateUrl: './ian-default-toolbar.component.html',
  styleUrls: ['./ian-default-toolbar.component.scss'],
  animations: [transitions],
})
@DestroySubscribers()
export class DefaultToolbarComponent implements OnInit {
  @ContentChild('wrapper', /* TODO: add static flag */ { read: null, static: true }) wrapper: ElementRef;

  @ViewChild('searchInput', { static: true })
  searchInput: ElementRef;

  @Select(AppState.IsAdvancedSearch)
  isAdvancedSearch$: Observable<boolean>;
  @Input() showMobileMenu = true;
  @Input() minLength = 3;
  @Input() actions: Array<ToolbarItemModel>;
  // @Input() queryText: string;

  @Output() actionExecuted: EventEmitter<ToolbarItemModel> = new EventEmitter();

  @Output() filterSearch: EventEmitter<string> = new EventEmitter();

  inputFlex = 50;
  action: ToolbarItemModel;

  @Input() showTextSearchInput = true;
  @Input() disableTextSearchInput = false;

  private subscribers: any = {};
  private isFullscreen = false;
  private fullscreenFunctionExecuted = false; // Indicador para marcar si la función se ejecutó después de cerrar la pantalla completa

  constructor(private mediaObserver: MediaObserver) {}

  ngOnInit(): void {
    // Link: https://www.freakyjolly.com/angular-7-6-add-debounce-time-using-rxjs-6-x-x-to-optimize-search-input-for-api-results-from-server/
    this.subscribers.keyup$ = fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        map((event: any) => {
          // get value
          return event.target.value;
        }),
        filter(
          res => res.length === 0 || res.length >= this.minLength /*filter will trigger if character length is greater than minLength */
        ),
        debounceTime(400 /* Time in milliseconds between key events */)
        //distinctUntilChanged(/*  If previous query is diffent from current */) //no detecta bien cuando cambia el input
      )
      .subscribe((text: string) => {
        this.emitFilterValue(text);
      });
  }

  emitActionExecution(action): void {
    this.action = { ...action };
    this.actionExecuted.emit(action);
    if (this.action.type == 'fullScreen') {
      this.fullscreenFunctionExecuted = true; // Marcar que la función se ha ejecutado
    }
  }

  @HostListener('document:fullscreenchange', ['$event'])
  handleFullscreenChange(event: Event) {
    this.isFullscreen = !!document.fullscreenElement;
    if (!this.isFullscreen) {
      // La pantalla ya no está en modo de pantalla completa
      // Verificar si la función se ejecutó después de cerrar la pantalla completa
      if (!this.fullscreenFunctionExecuted) {
        this.action.icon = 'fullscreen';
        this.action.tooltip = 'Expandir';
        this.emitActionExecution(this.action);
      }
      // Reiniciar el estado del indicador para la próxima vez
    }
    this.fullscreenFunctionExecuted = false;
  }

  /**
   * applyFilter Filtrado de items en dataSource
   * @param {string} filterValue
   * @returns {void}
   */
  emitFilterValue(text: string): void {
    this.filterSearch.emit(text);
  }

  isGtSm(): boolean {
    const rv = this.mediaObserver.isActive('gt-sm');

    return rv;
  }
}
